module.exports = __webpack_public_path__ + "img/161.8e649ffd.jpg";